import { ControlType, FormFieldBase } from './form-field-base.model';

export class SliderFormField extends FormFieldBase<number> {
  controlType: ControlType = 'slider';
}
